import { createTheme } from "@mui/material/styles";

const baseTheme = {
  typography: {
    fontFamily: "'Inter', system-ui, sans-serif",
    fontSize: 13,
    h5: { fontSize: "1.375rem" },
  },
  shape: { borderRadius: 8 },
};

export const muiLightTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: "light",
    primary: { main: "#0f766e", dark: "#115e59" },
    error: { main: "#dc2626" },
    success: { main: "#16a34a" },
    warning: { main: "#d97706" },
    background: { default: "#f4f5f7", paper: "#ffffff" },
    text: {
      primary: "#111827",
      secondary: "#6b7280",
      disabled: "#9ca3af",
    },
  },
});

export const muiDarkTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: "dark",
    primary: { main: "#0f766e", dark: "#0d9488" },
    error: { main: "#dc2626" },
    success: { main: "#16a34a" },
    warning: { main: "#d97706" },
    background: { default: "#0f172a", paper: "#1e293b" },
    text: {
      primary: "#f1f5f9",
      secondary: "#94a3b8",
      disabled: "#64748b",
    },
  },
});
